import { mockDb } from './mockData';

const INSTANCE = '56134_camp_fbwm';
const SECRET_KEY = 'f9b2ab85922e1d0d01fc2cf706f01e69d9acfa24396933c978478425b9e0';
const BASE_URL = 'https://app.nocodebackend.com/api/data';

export const api = {
  async get(collection, query = {}) {
    // FIX: Always fetch up to 1000 records by default to prevent data from hiding on page 2
    const defaultQuery = { limit: 1000, ...query };
    const qs = new URLSearchParams(defaultQuery).toString();
    const url = `${BASE_URL}/read/${collection}?${qs}&Instance=${INSTANCE}`;
    
    const res = await fetch(url, {
      headers: {
        'Authorization': `Bearer ${SECRET_KEY}`,
        'X-Database-Instance': INSTANCE
      }
    });
    
    const json = await res.json();
    if (!res.ok || json.status === 'error') {
      throw new Error(json.message || json.error || `GET ${collection} failed`);
    }
    return json;
  },

  async post(collection, data) {
    const url = `${BASE_URL}/create/${collection}?Instance=${INSTANCE}`;
    
    const res = await fetch(url, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${SECRET_KEY}`,
        'X-Database-Instance': INSTANCE,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });
    
    const json = await res.json();
    if (!res.ok || json.status === 'error') {
      throw new Error(json.message || json.error || `POST ${collection} failed`);
    }
    return json;
  },

  async put(collection, id, data) {
    const url = `${BASE_URL}/update/${collection}/${id}?Instance=${INSTANCE}`;
    
    const res = await fetch(url, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${SECRET_KEY}`,
        'X-Database-Instance': INSTANCE,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });
    
    const json = await res.json();
    if (!res.ok || json.status === 'error') {
      throw new Error(json.message || json.error || `PUT ${collection} failed`);
    }
    return json;
  },

  async delete(collection, id) {
    const url = `${BASE_URL}/delete/${collection}/${id}?Instance=${INSTANCE}`;
    
    const res = await fetch(url, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${SECRET_KEY}`,
        'X-Database-Instance': INSTANCE
      }
    });
    
    const json = await res.json();
    if (!res.ok || json.status === 'error') {
      throw new Error(json.message || json.error || `DELETE ${collection} failed`);
    }
    return json;
  }
};